
import Vue from "vue";
import { Company } from "@/models/company";
import { InvoiceAddress } from "@/models/invoice-address";
import { CompanyService } from "@/services/company-service";
import AppLabel from "../LabelWithValue.vue";
import AppCompanyEditWrapper from "./CompanyEditWrapper.vue";

export default Vue.extend({
	data(){
		return {
			address: new InvoiceAddress(),
		};
	},
	props: {
		company: {
			type: Object as ()=>Company,
			required: true
		}
	},
	async created(){
		this.address = await CompanyService.getInvoiceAddress(this.company);
	},
	components: {
		AppLabel,
		AppCompanyEditWrapper
	}
});
